import { z } from "zod";
import sceneObjectDataSchema from "./sceneObjectDataSchema";
import { vector3dSchema } from "../../primitivesSchema";
import apiPlacementSchema from "../../placementSchema";

const areaAnnotationDataSchema = sceneObjectDataSchema.extend({
    placement: apiPlacementSchema,
    points: z.array(vector3dSchema),
    depth: z.number(),
    extrudedDirection: vector3dSchema,
    fontSize: z.number().optional(),
    showAreaText: z.boolean().optional(),
    showVolume: z.boolean().optional()
  });

export default areaAnnotationDataSchema;
